import ToolStylus from './ToolStylus';
import promoImage from '../assets/promotions/ahaAssistantPromo.svg';

class ToolStylusAssistantPromo extends ToolStylus {
  static toolName = 'AI assistant';

  static popover() {
    return {
      title: 'AI assistant',
      description:
        'Use text prompts and screenshots to quickly create visual designs.',
      image: promoImage,
    };
  }

  static action() {
    return true;
  }
}

export default ToolStylusAssistantPromo;
